import moment from 'moment'

import { getDb, globalWatcherUnsub, mapTaskData } from '../firestore'
import { setMyDayWorkflowTasks } from '../../../redux/actions'
import store from '../../../redux/store'
import { compareTasksByPriorityThenCompleted } from '../../TaskPriority'
import { FEED_PUBLIC_FOR_ALL } from '../../../components/Feeds/Utils/FeedsConstants'

function addTaskToContainers(tasks, subtasksMap, task) {
    const { parentId } = task
    if (parentId) {
        subtasksMap[parentId] ? subtasksMap[parentId].push(task) : (subtasksMap[parentId] = [task])
    } else {
        tasks.push(task)
    }
}

export async function watchPendingTasksToReview(projectId, userId, watcherKey) {
    const endOfDay = moment().endOf('day').valueOf()
    const { uid: loggedUserId, isAnonymous } = store.getState().loggedUser
    const accessReaderId = isAnonymous ? FEED_PUBLIC_FOR_ALL : loggedUserId

    globalWatcherUnsub[watcherKey] = getDb()
        .collection(`items/${projectId}/tasks`)
        .where('userId', '==', userId)
        .where('inDone', '==', false)
        .where('readerIds', 'array-contains', accessReaderId)
        .where('completed', '<=', endOfDay)
        .orderBy('completed', 'desc')
        .onSnapshot(docs => {
            const tasks = []
            const subtasksMap = {}

            docs.forEach(doc => {
                const task = mapTaskData(doc.id, doc.data())
                const { currentReviewerId } = task
                if (currentReviewerId !== userId) {
                    task.projectId = projectId
                    addTaskToContainers(tasks, subtasksMap, task)
                }
            })
            tasks.sort(compareTasksByPriorityThenCompleted)
            store.dispatch(setMyDayWorkflowTasks(projectId, tasks, subtasksMap))
        })
}
